// F6 / Shift+F6 between panes (C# twin windows/src/SatoriChat.Core/Logic/KeyboardMap.cs `NextPane`,
// PARITY P339). Reading order: sidebar → conversation → thread pane, wrapping, skipping panes that
// are not on screen. Ctrl+Tab / Ctrl+Shift+Tab is the Windows step between conversations; browsers
// RESERVE it (and Ctrl+PgUp/PgDn) for their own tabs and never deliver it to a page, so the web
// answers it only where it is delivered (an installed app window may) and keeps ⌥↑/⌥↓ (Alt+↑/↓).

/** The next pane among those on screen; `current` = the pane holding focus now (-1 = none). */
function nextPane(visible: readonly boolean[], current: number, backwards: boolean): number {
  const n = visible.length;
  if (n === 0 || !visible.some((v) => v)) return -1;
  const step = backwards ? -1 : 1;
  let i = current < 0 ? (backwards ? 0 : n - 1) : current;
  for (let k = 0; k < n; k++) {
    i = (((i + step) % n) + n) % n;
    if (visible[i]) return i;
  }
  return -1;
}

export const KeyboardPanes = { nextPane } as const;
